import Button from '../../Button';
import styles from './style.m.less';

export default function NotificationsMarkAllAsReadButton({ onClick }) {
    return (
        <Button
            kind="PLAIN"
            className={styles.button}
            onClick={onClick}
            eventTracking={{ category: 'notifications', action: 'mark', label: 'all as read' }}
        >
            Mark all as read
        </Button>
    );
}
